export default __webpack_public_path__ + "static/media/thailand.f5706374.jpg";